import type { DecisionEngineDestinationDefinition } from "./definition";
import { hightouchMappingWithTags } from "./sync-config-helpers";

export const klaviyoDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "klaviyo",
  category: "event",
  generateSyncConfig: ({ flowId, channelType, messageTags }) => ({
    type: "event",
    eventName: "hightouch_interaction",
    externalIdMapping: { from: "external_id", to: "email" },
    mappings: [],
    customMappings: [
      hightouchMappingWithTags(messageTags),
      { type: "standard", from: "campaign_id", to: "message_identifier" },
      {
        type: "static",
        value: flowId,
        valueType: "STRING",
        to: "agent_identifier",
      },
      {
        type: "static",
        value: channelType,
        valueType: "STRING",
        to: "channel",
      },
    ],
  }),
  syncStrategy: {
    supportsChannelLevelSync: false,
  },
};
